import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
  selected: {},
  isLoaded: false,
  questionAnswers: [],
  questionComplaint: "",
  questionComplaintDetail: "",
};

const treatmentDemandQuestionsSlice = createSlice({
  name: "treatmentDemandQuestion",
  initialState,
  reducers: {
    clearConsentForm: (state) => {
      state.questionComplaint = "";
      state.questionComplaintDetail = "";
      state.questionAnswers = [];
      // if(state.questionAnswers.length > 0){
      //   state.questionAnswers = state.questionAnswers.map(e => {
      //     return {...e, answer: ""}
      //   })
      // }
    },
    setQuestionComplaint: (state, { payload }) => {
      state.questionComplaint = payload
    },
    setQuestionComplaintDetail: (state, { payload }) => {
      state.questionComplaintDetail = payload
    },
    setQuestions: (state, { payload }) => {
      state.questionAnswers = payload.map(q => {
        if (q.answerType === "Text") {
          return { ...q, answer: "" }
        } else {
          return { ...q, answer: [] }
        }
      });
    },
    setAnswer: (state, { payload }) => {
      state.questionAnswers = state.questionAnswers.map(q => {
        if (q.id === payload.id) {
          return { ...q, answer: payload.value };
        } else return q;
      })
    },
    setOptionAnswer: (state, { payload }) => {
      state.questionAnswers = state.questionAnswers.map(q => {
        if (q.id === payload.id) {
          let answers = [...q.answer];
          answers.push(payload.value)
          return { ...q, answer: answers }
        } else return q;
      });
    },
    removeOptionAnswer: (state, { payload }) => {
      state.questionAnswers = state.questionAnswers.map(q => {
        if (q.id === payload.id) {
          return { ...q, answer: q.answer.filter(d => d !== payload.value) }
        } else return q;
      })
    },
    setTreatmentDemandsQuestions: (state, { payload }) => {
      state.list = payload;
      console.log('[treatmentDemandQuestionsSlice] Payload:', payload);
    },
    addTreatmentDemandsQuestionsToList: (state, { payload }) => {
      state.list = [payload, ...state.list];
    },
    updateTreatmentDemandsQuestions: (state, { payload }) => {
      state.list = state.list.map((item) => {
        if (item.id === payload.id) {

          console.log('[treatmentDemandQuestionsSlice] Item ve payload:', item, payload, "ii");
          return { ...item, ...payload }
        } else return item
      }
      );
    },
    removeTreatmentDemandsQuestionsFromList: (state, { payload }) => {
      state.list = state.list.filter((item) => item.id !== payload);
    },
    setSelectedTreatmentDemandsQuestions: (state, { payload }) => {
      state.selected = payload;
    },
    clearSelectedQuesions: (state, { payload }) => {
      state.selected = {};
    },
  },
});
export const {
  setTreatmentDemandsQuestions,
  addTreatmentDemandsQuestionsToList,
  updateTreatmentDemandsQuestions,
  removeTreatmentDemandsQuestionsFromList,
  setSelectedTreatmentDemandsQuestions,
  clearSelectedQuesions,
  setQuestions,
  setAnswer,
  setQuestionComplaint,
  setQuestionComplaintDetail,
  setOptionAnswer,
  removeOptionAnswer,
  clearConsentForm,

} = treatmentDemandQuestionsSlice.actions;
export default treatmentDemandQuestionsSlice.reducer;
